import { AssessmentQuestion } from '@/types/assessment';

export const questionData: AssessmentQuestion[] = [
  // Basic Personality Traits (Questions 1-12)
  {
    id: 1,
    text: "I prefer to complete a task even if it's boring or difficult.",
    malayalamText: "എനിക്ക് രസകരമല്ലാത്തതോ ദുഷ്‌കരമോ ആയ ജോലികൾ പൂർത്തിയാക്കാൻ മുൻഗണന നൽകുന്നു.",
    category: "Basic Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 2,
    text: "I am comfortable working alone without supervision.",
    malayalamText: "മേൽനോട്ടമില്ലാതെ സ്വതന്ത്രമായി പ്രവർത്തിക്കുമ്പോൾ എനിക്ക് ആശ്വാസം ലഭിക്കുന്നു.",
    category: "Basic Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 3,
    text: "When I commit to something, I follow through even if it's challenging.",
    malayalamText: "ഞാൻ എന്തെങ്കിലും പ്രതിജ്ഞാബദ്ധമാകുമ്പോൾ അതിന് എത്ര കഠിനമാണെങ്കിലും ഞാൻ പൂര്‍ത്തിയാക്കും.",
    category: "Basic Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 4,
    text: "I prefer having a clear set of rules before starting a task.",
    malayalamText: "ഒരു ജോലി തുടങ്ങുന്നതിനുമുന്‍പ് വ്യക്തമായ നിബന്ധനകള്‍ ഉണ്ടാകുന്നതാണ് എനിക്ക് ഇഷ്ടം.",
    category: "Basic Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 5,
    text: "I avoid procrastination and stick to a schedule.",
    malayalamText: "ഞാൻ വൈകിപ്പിക്കുന്നതൊഴിവാക്കി, സമയക്രമം പാലിക്കാൻ ശ്രമിക്കുന്നു.",
    category: "Basic Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 6,
    text: "I am open to receiving feedback and improving myself.",
    malayalamText: "ഞാൻ ഫീഡ്ബാക്ക് സ്വീകരിച്ച് അതിലൂടെ പുരോഗതി നേടാൻ തയ്യാറാണ്.",
    category: "Basic Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 7,
    text: "Work-life balance is very important to me.",
    malayalamText: "ജോലി ജീവിതത്തിന്റെയും വ്യക്തിഗത ജീവിതത്തിന്റെയും സംതുലിതാവസ്ഥ എനിക്ക് വളരെ പ്രധാനമാണ്.",
    category: "Basic Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 8,
    text: "I prefer working with deadlines rather than open-ended tasks.",
    malayalamText: "നിശ്ചിത സമയപരിധിയുള്ള ജോലികൾ ആണ് എനിക്ക് ഇഷ്ടം.",
    category: "Basic Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 9,
    text: "I am able to adapt quickly to unexpected changes.",
    malayalamText: "അപ്രതീക്ഷിതമായ മാറ്റങ്ങളോട് എനിക്ക് വേഗത്തിൽ ഇണങ്ങാൻ കഴിയും.",
    category: "Basic Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 10,
    text: "I handle stress well under pressure.",
    malayalamText: "സമ്മർദ്ദാവസ്ഥകളിൽ എനിക്ക് സംവരണം മനസ്സിലാക്കി മുന്നോട്ട് പോകാൻ കഴിയും.",
    category: "Basic Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 11,
    text: "I am comfortable taking calculated risks.",
    malayalamText: "കൃത്യമായി കണക്കുകൂട്ടിയ റിസ്ക്കുകൾ എടുക്കുന്നതിനു ഞാൻ തയ്യാറാണ്.",
    category: "Basic Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 12,
    text: "I feel confident handling unexpected situations independently.",
    malayalamText: "അപ്രതീക്ഷിതമായ സാഹചര്യങ്ങൾ സ്വതന്ത്രമായി കൈകാര്യം ചെയ്യുന്നതിൽ എനിക്ക് ആത്മവിശ്വാസമുണ്ട്.",
    category: "Basic Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  
  // Career-Oriented Personality Traits (Questions 13-32)
  {
    id: 13,
    text: "I prefer working with people rather than data.",
    malayalamText: "ഡാറ്റയേക്കാൾ ആളുകളുമായി പ്രവർത്തിക്കാനാണ് എനിക്ക് ഇഷ്ടം.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 14,
    text: "I enjoy solving complex problems.",
    malayalamText: "സങ്കീർണ്ണമായ പ്രശ്നങ്ങൾ പരിഹരിക്കുന്നതിൽ എനിക്ക് സന്തോഷം അനുഭവപ്പെടുന്നു.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 15,
    text: "I prefer working in a team rather than independently.",
    malayalamText: "സ്വതന്ത്രമായി പ്രവർത്തിക്കുന്നതിനേക്കാൾ ടീം ആയി പ്രവർത്തിക്കാനാണ് എനിക്ക് ഇഷ്ടം.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 16,
    text: "I am comfortable taking leadership roles when needed.",
    malayalamText: "ആവശ്യമായപ്പോൾ നേതൃത്വം ഏറ്റെടുക്കാൻ എനിക്ക് കഴിയുന്നു.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 17,
    text: "I prefer creative work over technical work.",
    malayalamText: "സാങ്കേതിക ജോലികൾക്കു പകരം സൃഷ്ടിപരമായ ജോലികൾ ആണ് എനിക്ക് ഇഷ്ടം.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 18,
    text: "I am comfortable taking initiative in uncertain situations.",
    malayalamText: "അനിശ്ചിത സാഹചര്യങ്ങളിൽ തുടക്കം കുറിക്കാൻ എനിക്ക് ആത്മവിശ്വാസമുണ്ട്.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 19,
    text: "Job security is very important to me.",
    malayalamText: "ജോലി സുരക്ഷ എനിക്ക് ഏറെ പ്രാധാന്യമാണ്.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 20,
    text: "I prefer working with my hands rather than using technology.",
    malayalamText: "സാങ്കേതിക വിദ്യയ്ക്കു പകരം കൈകളാൽ പ്രവർത്തിക്കാനാണ് എനിക്ക് ഇഷ്ടം.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 21,
    text: "I prefer variety over stability in my work life.",
    malayalamText: "സ്ഥിരതയ്ക്കു പകരം വൈവിധ്യമുള്ള ജോലി ജീവിതം ആണ് എനിക്ക് ഇഷ്ടം.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 22,
    text: "I am comfortable learning new skills regularly.",
    malayalamText: "പുതിയ കഴിവുകൾ നിരന്തരം അഭ്യസിക്കാൻ ഞാൻ തയ്യാറാണ്.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 23,
    text: "I prefer following existing rules rather than creating new ones.",
    malayalamText: "പുതിയ നിയമങ്ങൾ ഉണ്ടാക്കുന്നതിനേക്കാൾ നിലവിലുള്ള നിയമങ്ങൾ പാലിക്കാനാണ് ഞാൻ തയ്യാറാകുന്നത്.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 24,
    text: "I enjoy focusing on the big picture more than the details.",
    malayalamText: "ചെറിയ ചെറിയ കാര്യങ്ങൾക്ക് പകരം സമഗ്ര ദൃശ്യത്തെയാകെയാണ് ഞാൻ കൂടുതൽ ശ്രദ്ധിക്കുന്നത്.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 25,
    text: "Making a social impact through my work is important to me.",
    malayalamText: "എന്റെ ജോലിയിൽ സാമൂഹിക സ്വാധീനം ഉണ്ടാക്കാൻ എനിക്ക് ആഗ്രഹമുണ്ട്.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 26,
    text: "I feel comfortable working in high-energy, fast-paced environments.",
    malayalamText: "അതിവേഗവും ഉയർന്ന ഊർജ്ജവും ഉള്ള പരിതസ്ഥിതികളിൽ എനിക്ക് പ്രവർത്തിക്കാൻ കഴിയും.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 27,
    text: "I enjoy working in competitive environments.",
    malayalamText: "മത്സരപരമായ സാഹചര്യത്തിൽ പ്രവർത്തിക്കാൻ എനിക്ക് സന്തോഷമുണ്ട്.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 28,
    text: "I am comfortable with uncertainty and ambiguity at work.",
    malayalamText: "ജോലിയിൽ അനിശ്ചിതത്വവും ആശയക്കുഴപ്പവും എനിക്ക് കൈകാര്യം ചെയ്യാൻ കഴിയും.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 29,
    text: "Freedom and flexibility are more important to me than structure.",
    malayalamText: "ഘടനക്കു പകരം സ്വാതന്ത്ര്യവും ഇളവുമാണ് എനിക്ക് പ്രധാന്യം.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 30,
    text: "I seek out challenges rather than avoiding them.",
    malayalamText: "പ്രശ്നങ്ങൾ ഒഴിവാക്കുന്നതിനേക്കാൾ അതിനെ നേരിടാൻ ഞാൻ ശ്രമിക്കും.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 31,
    text: "I am comfortable multitasking.",
    malayalamText: "ഒന്നിലധികം ജോലികൾ ഒരേ സമയം ചെയ്യാൻ എനിക്ക് കഴിയുന്നു.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 32,
    text: "I prefer work with clear outcomes rather than exploration-based work.",
    malayalamText: "അന്വേഷണപരമായ ജോലികൾക്കു പകരം വ്യക്തമായ ഫലങ്ങൾ ലഭിക്കുന്ന ജോലികളാണ് എനിക്ക് ഇഷ്ടം.",
    category: "Career-Oriented Personality Traits",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  
  // Skills, Interests, and Passions (Questions 33-52)
  {
    id: 33,
    text: "I enjoy working with numbers and data.",
    malayalamText: "എനിക്ക് അക്കൗണ്ടിംഗ്, ഡാറ്റ തുടങ്ങിയവയുമായി പ്രവർത്തിക്കാൻ ഇഷ്ടമാണ്.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 34,
    text: "I feel comfortable with public speaking.",
    malayalamText: "പൊതുപ്രസംഗത്തിൽ എനിക്ക് ആശ്വാസം ലഭിക്കുന്നു.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 35,
    text: "I enjoy working with my hands.",
    malayalamText: "കൈകൊണ്ട് പ്രവർത്തിക്കുമ്പോൾ എനിക്ക് സന്തോഷമുണ്ട്.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 36,
    text: "I prefer working indoors rather than outdoors.",
    malayalamText: "Outdoor നേക്കാളും Indoor ജോലികൾ ചെയ്യാനാണ് എനിക്കിഷ്ടം.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 37,
    text: "I am more motivated by personal fulfillment than financial gain.",
    malayalamText: "സാമ്പത്തിക നേട്ടത്തിനു പകരം വ്യക്തിഗത തൃപ്തിയാണ് എനിക്ക് പ്രധാനം.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 38,
    text: "I feel energized when helping others.",
    malayalamText: "മറ്റുള്ളവരെ സഹായിക്കുമ്പോൾ എനിക്ക് ഊർജ്ജം അനുഭവപ്പെടുന്നു.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 39,
    text: "I prefer working with people rather than numbers.",
    malayalamText: "നമ്ബറുകൾക്കു പകരം ആളുകളുമായാണ് എനിക്ക് പ്രവർത്തിക്കാൻ ഇഷ്ടം.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 40,
    text: "Creativity is essential for me in my work.",
    malayalamText: "എന്റെ ജോലിയിൽ സൃഷ്ടിപരമായ പ്രവൃത്തികൾ എന്നെ ആകർഷിക്കുന്നു.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 41,
    text: "I enjoy analytical tasks like problem-solving and data analysis.",
    malayalamText: "പ്രശ്നപരിഹാരവും ഡാറ്റാ വിശകലനവും പോലുള്ള ജോലികൾ എനിക്ക് ഇഷ്ടമാണ്.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 42,
    text: "I feel comfortable working in a high-pressure environment.",
    malayalamText: "ഉയർന്ന സമ്മർദ്ദാവസ്ഥകളിൽ എനിക്ക് പ്രവർത്തിക്കാൻ കഴിയുന്നു.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 43,
    text: "I enjoy leading group projects or initiatives.",
    malayalamText: "ഗ്രൂപ്പ് പ്രോജക്റ്റുകൾക്ക് നേതൃത്വം നൽകാൻ എനിക്ക് കഴിയുന്നു.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 44,
    text: "I am interested in exploring different career paths.",
    malayalamText: "വ്യത്യസ്തമായ തൊഴിൽ മേഖലകൾ പരിശോധിക്കാൻ എനിക്ക് താൽപ്പര്യമുണ്ട്.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 45,
    text: "I prefer tasks that require logical thinking over emotional intelligence.",
    malayalamText: "വികാരബുദ്ധിയേക്കാൾ താൽക്കാലിക ചിന്തകൾക്ക് മുൻഗണന നൽകുന്നു.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 46,
    text: "I am naturally good at managing my time effectively.",
    malayalamText: "എന്റെ സമയം ഫലപ്രദമായി നിയന്ത്രിക്കാൻ എനിക്ക് കഴിയും.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 47,
    text: "I feel comfortable using new technology or software.",
    malayalamText: "പുതിയ സാങ്കേതികവിദ്യകൾ ഉപയോഗിക്കാൻ എനിക്ക് താല്പര്യമാണ്.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 48,
    text: "I am drawn to creative professions (art, writing, music).",
    malayalamText: "കല, എഴുത്ത്, സംഗീതം തുടങ്ങിയ സൃഷ്ടിപരമായ ജോലികളിലേക്ക് ഞാൻ ആകർഷിക്കപ്പെടുന്നു.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 49,
    text: "I am more comfortable with clear instructions than vague guidelines.",
    malayalamText: "വ്യക്തമായ നിർദേശങ്ങൾ എനിക്ക് ആശ്വാസം നൽകുന്നു.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 50,
    text: "I prefer to work on one task at a time rather than multitasking.",
    malayalamText: "ഒന്നിലധികം ജോലികൾ ഒരേ സമയം ചെയ്യുന്നതിനേക്കാൾ ഒറ്റ ജോലിയിലാണ് ഞാൻ താൽപ്പര്യമുള്ളത്.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 51,
    text: "I am motivated by recognition and success.",
    malayalamText: "അംഗീകാരംയും വിജയവുമാണ് എനിക്ക് പ്രേരകശക്തി.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 52,
    text: "I am interested in learning about global industries and markets.",
    malayalamText: "ആഗോള വ്യവസായങ്ങളും വിപണികളും മനസ്സിലാക്കുന്നതിൽ എനിക്ക് താൽപ്പര്യമുണ്ട്.",
    category: "Skills, Interests, and Passions",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  
  // Decision-Making Style (Questions 53-62)
  {
    id: 53,
    text: "I analyze all available information before making a decision.",
    malayalamText: "ഒരു തീരുമാനം എടുക്കുന്നതിന് മുമ്പ് ഞാൻ എല്ലാ വിവരങ്ങളും വിശകലനം ചെയ്യും.",
    category: "Decision-Making Style",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 54,
    text: "I rely more on intuition than facts when making decisions.",
    malayalamText: "വിവരങ്ങളെക്കാൾ എന്റെ ഇന്ദ്രിയങ്ങൾ ആണ് ഞാൻ കൂടുതലായി ആശ്രയിക്കുന്നത്.",
    category: "Decision-Making Style",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 55,
    text: "I am comfortable seeking advice before making decisions.",
    malayalamText: "ഒരു തീരുമാനം എടുക്കുന്നതിന് മുമ്പ് ഞാൻ ഉപദേശം തേടും.",
    category: "Decision-Making Style",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 56,
    text: "I prefer to take my time when making big decisions.",
    malayalamText: "വലിയ തീരുമാനങ്ങൾ എടുക്കുമ്പോൾ ഞാൻ സമയം എടുത്തു ചിന്തിക്കും.",
    category: "Decision-Making Style",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 57,
    text: "I trust my instincts when faced with uncertainty.",
    malayalamText: "അനിശ്ചിതത്വത്തിന്റെ സാഹചര്യങ്ങളിൽ എന്റെ ഉള്ളുണര്‍വ് ആണ് ഞാൻ ആശ്രയിക്കുന്നത്.",
    category: "Decision-Making Style",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 58,
    text: "I prefer structured decision-making over flexible approaches.",
    malayalamText: "കൃത്യമായ രീതിയിലുള്ള തീരുമാനമെടുക്കൽ എന്നെ കൂടുതൽ ആകർഷിക്കുന്നു.",
    category: "Decision-Making Style",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 59,
    text: "I am comfortable adapting my decisions if new information arises.",
    malayalamText: "പുതിയ വിവരങ്ങൾ ലഭിക്കുമ്പോൾ ഞാൻ തീരുമാനങ്ങൾ മാറ്റാൻ തയ്യാറാണ്.",
    category: "Decision-Making Style",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 60,
    text: "I tend to overthink decisions before acting on them.",
    malayalamText: "ഞാൻ ഒരു തീരുമാനം എടുക്കുന്നതിന് മുമ്പ് അതിനെ കൂടുതൽ ചിന്തിക്കും.",
    category: "Decision-Making Style",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 61,
    text: "I feel confident making independent decisions.",
    malayalamText: "സ്വതന്ത്രമായി തീരുമാനങ്ങൾ എടുക്കുന്നതിൽ എനിക്ക് ആത്മവിശ്വാസമുണ്ട്.",
    category: "Decision-Making Style",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  {
    id: 62,
    text: "I prefer to have a backup plan when making decisions.",
    malayalamText: "ഒരു തീരുമാനം എടുക്കുമ്പോൾ ബാക്കപ്പ് പ്ലാൻ ഉണ്ടാക്കാൻ ഞാൻ താല്പര്യപ്പെടുന്നു.",
    category: "Decision-Making Style",
    options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"]
  },
  
  // Study Abroad & Financial Profile (Only Question 63)
  {
    id: 63,
    text: "If you had the opportunity to study abroad, which continent would you prefer?",
    malayalamText: "നിങ്ങൾക്ക് വിദേശത്ത് പഠിക്കാൻ അവസരം ലഭിച്ചാൽ ഏത് ഭൂഖണ്ഡത്തെയാണ് നിങ്ങൾ തിരഞ്ഞെടുക്കുക?",
    category: "Study Abroad & Financial Profile",
    options: ["Europe", "North America", "Asia", "Australia", "Not Interested"]
  }
];
